import config from '../../../../../config';

const generateTransferUrl = (ticketId: string) => {
  const baseShareUrl = `${config.SITE_URL}tickets/transfer`;
  return `${baseShareUrl}/${ticketId}`;
};

export default generateTransferUrl;
